/**
 * Tiny pub/sub bridging `client/src/index.js` (module scope, outside the
 * React tree — where `serviceWorkerRegistration.register()`'s `onUpdate`
 * callback fires per the cra-template-pwa pattern) to `<UpdateBanner />`.
 * `notifyUpdateAvailable` is called at most once per page load in practice,
 * but keeps the last registration around so a banner that mounts AFTER the
 * event already fired (e.g. re-render, or a route change remounting it)
 * still shows it instead of missing the update silently.
 */
let listener = null;
let lastRegistration = null;
let updateAccepted = false;

export function notifyUpdateAvailable(registration) {
  lastRegistration = registration;
  if (listener) listener(registration);
}

export function subscribeToUpdate(callback) {
  listener = callback;
  if (lastRegistration) callback(lastRegistration);
  return () => {
    if (listener === callback) listener = null;
  };
}

/**
 * Set by `UpdateBanner` right before it posts `SKIP_WAITING` (fix round 1,
 * review finding): `clientsClaim()` in `service-worker.js` makes the new
 * worker take control — and fire `controllerchange` — the very first time
 * ANY worker installs, not only after an accepted update (a brand new
 * visitor, or someone who just cleared site data, has no previous
 * controller either). `reloadOnAcceptedUpdate` checks this flag so that
 * first-install `controllerchange` stays silent and only a real "Actualizar"
 * click reloads the page.
 */
export function markUpdateAccepted() {
  updateAccepted = true;
}

export function wasUpdateAccepted() {
  return updateAccepted;
}
